var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.318,
    height: 13.036,
    viewBox: "22.157 157.039 19.318 13.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.306 168.922 8.935-11.592a.714.714 0 0 1 1.14-.013l8.909 11.56a.717.717 0 0 1-.531 1.198H22.872v-.002a.713.713 0 0 1-.566-1.151Z",
    fill: "#0ea552",
    fillRule: "evenodd",
    "data-name": "triangle-top-icon"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.9edf92d85776fb076a553a87cf905124.svg";
export { ForwardRef as ReactComponent };